(function(){
  var timerInterval = null;
  
  var getJapanMidnight = function() {
    var now = new Date();
    var japanOffset = 9 * 60;
    var japanTime = new Date(now.getTime() + (japanOffset + now.getTimezoneOffset()) * 60000);
    var midnight = new Date(japanTime);
    midnight.setHours(23, 59, 59, 999);
    return new Date(midnight.getTime() - (japanOffset + now.getTimezoneOffset()) * 60000);
  };

  var initTimer = function() {
    var endTime = getJapanMidnight().getTime();
    var currentTime = new Date().getTime();
    var timeLeft = endTime - currentTime;
    
    document.querySelectorAll(".countdown-bar-js").forEach(function(timer) {
      if (timeLeft <= 0) {
        timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = "00";
        timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = "00";
        timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = "00";
        timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = "00";
        return;
      }
      var hours = Math.floor(timeLeft / (1e3 * 60 * 60));
      var minutes = Math.floor(timeLeft % (1e3 * 60 * 60) / (1e3 * 60));
      var seconds = Math.floor(timeLeft % (1e3 * 60) / 1e3);
      timer.querySelector(".countdown-bar__days .countdown-bar__number").textContent = "00";
      timer.querySelector(".countdown-bar__hours .countdown-bar__number").textContent = String(hours).padStart(2, "0");
      timer.querySelector(".countdown-bar__min .countdown-bar__number").textContent = String(minutes).padStart(2, "0");
      timer.querySelector(".countdown-bar__sec .countdown-bar__number").textContent = String(seconds).padStart(2, "0");
    });
  };
  
  var startTimer = function() {
    if (timerInterval) clearInterval(timerInterval);
    initTimer();
    timerInterval = setInterval(initTimer, 1000);
  };
  
  var stopTimer = function() {
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = null;
  };

  // Start immediately regardless of visibility
  startTimer();
  
  // Also handle visibility changes
  document.addEventListener("visibilitychange", function() {
    if (!document.hidden) {
      startTimer();
    } else {
      stopTimer();
    }
  });
  
  document.addEventListener("shopify:section:load", function() {
    startTimer();
  });
})();